module.exports = __webpack_public_path__ + "static/media/0018.77676fe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48104/Decors_colored/G04_white/0018.png
// module id = 1968
// module chunks = 0